import { selectOutskirtBuildingUpgradeMissingRequirements } from "../../../../selectors/selectOutskirtBuildingUpgradeInfo";
export var checkOutskirtBuildingHasEnoughResources = function (path) { return function (action, state$) {
    var state = state$.value;
    var outskirtBuildingId = action.building.balancing.id;
    var missingResources = selectOutskirtBuildingUpgradeMissingRequirements(state, outskirtBuildingId);
    if (missingResources.length > 0) {
        return path;
    }
}; };



//////////////////
// WEBPACK FOOTER
// ./src/features/info/outskirts/checks/checkOutskirtBuildingHasEnoughResources.ts
// module id = 1921
// module chunks = 3